"use client";

import { memo } from "react";

type SearchKeywordsListProps = {
  keywords: Array<{ keyword: string; keywordCount: number }>;
};

const SearchKeywordsList: React.FC<SearchKeywordsListProps> = ({
  keywords,
}) => {
  return (
    <div className="flex w-full flex-col gap-3 md:!gap-y-7 md:gap-x-8">
      {keywords.map((item, index) => (
        <div key={index} className="flex items-center gap-[6px]">
          <span className="text-xs font-medium leading-4 text-[#17142A]">
            {item.keyword}
          </span>

          <div className="inline-flex items-center gap-0.5 rounded bg-[#E8E8EB] px-1 py-0.5">
            <span className="text-[10px] font-normal leading-[14px] tracking-[0.4px] text-[#59566C]">
              {item.keywordCount} times
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default memo(SearchKeywordsList);
